import { isEmailValid } from 'Assets/js/helpers/jsutils';

function hasRequiredFields(fileFields) {
  if (fileFields.length === 0) {
    return true;
  }
  for (let i = 0; i < fileFields.length; ++i) {
    if (fileFields[i].files.length > 0) {
      return true; // has at least one file
    }
  }
  return false;
}

function toggleSubmit(form) {
  if (!form) return;

  const formValidity = form.checkValidity();
  const submitButton = form.querySelector('button.competition-submit-btn');
  const emailField = form.querySelector('input[type="email"]');
  const fileFields = form.querySelectorAll('input[type="file"]');

  if (
    formValidity &&
    emailField &&
    isEmailValid(emailField.value) &&
    hasRequiredFields(fileFields)
  ) {
    submitButton.classList.add('valid');
    submitButton.disabled = false;
  } else {
    submitButton.classList.remove('valid');
    submitButton.disabled = true;
  }
}

export default function prCompetitionJs(options = {}) {
  try {
    const form = document.querySelector('.competition_form');
    if (form) {
      const formElements = form.querySelectorAll('input, select, textarea');
      formElements.forEach((element) => {
        const tag = element.tagName.toLowerCase();
        const { type } = element;

        // Checkboxes: special handling
        if (type === 'checkbox') {
          element.addEventListener('change', function () {
            // only toggle active for MCQ section on change
            if (element.closest('._multiple-choice-area') !== null) {
              const labels = form.querySelectorAll('._option label');
              labels.forEach((el) => el.classList.remove('_option_checked'));
            }

            const label = element.parentElement;
            if (this.checked) {
              label.classList.add('_option_checked');
            }

            toggleSubmit(form);
          });
          return; // stop here for checkboxes
        }

        // Text-like inputs: validate as user is typing
        if (
          tag === 'textarea' ||
          (tag === 'input' &&
            [
              'text',
              'email',
              'password',
              'number',
              'search',
              'tel',
              'url'
            ].includes(type))
        ) {
          element.addEventListener('input', () => toggleSubmit(form));
          return;
        }

        // Everything else (file, select, radios): validate on change
        element.addEventListener('change', () => toggleSubmit(form));
      });
      // run once to disable the button on load
      toggleSubmit(form);
    }
  } catch (error) {
    console.error(error);
  }
}
